module.exports = __webpack_public_path__ + "img/beer_id-24.5c59e1c5.png";